(function () {
  "use strict";

  var ACTION = "article_club_doi";
  var SCRIPT_ID = "wynch-turnstile-api-v2";
  var SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var scriptPromise = null;

  function loadApi() {
    if (window.turnstile && typeof window.turnstile.render === "function") return Promise.resolve(window.turnstile);
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      var existing = document.getElementById(SCRIPT_ID);
      var script = existing || document.createElement("script");
      var timeout = window.setTimeout(function () { reject(new Error("TURNSTILE_SCRIPT_TIMEOUT_V2")); }, 15000);
      function ready() {
        window.clearTimeout(timeout);
        if (window.turnstile && typeof window.turnstile.render === "function") resolve(window.turnstile);
        else reject(new Error("TURNSTILE_API_UNAVAILABLE_V2"));
      }
      function failed() {
        window.clearTimeout(timeout);
        reject(new Error("TURNSTILE_SCRIPT_FAILED_V2"));
      }
      script.addEventListener("load", ready, { once: true });
      script.addEventListener("error", failed, { once: true });
      if (!existing) {
        script.id = SCRIPT_ID;
        script.src = SCRIPT_URL;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    });
    return scriptPromise;
  }

  function challenge(node) {
    var sitekey = String(node && node.dataset.clubTurnstileSitekey || "").trim();
    var host = node && node.querySelector("[data-club-turnstile-host]");
    if (!sitekey) return Promise.reject(new Error("TURNSTILE_SITEKEY_UNCONFIGURED_V2"));
    if (!host) return Promise.reject(new Error("TURNSTILE_HOST_MISSING_V2"));
    return loadApi().then(function (api) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var widgetId = null;
        var timeout = window.setTimeout(function () { finish(new Error("TURNSTILE_CHALLENGE_TIMEOUT_V2")); }, 120000);
        function finish(error, token) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          if (widgetId !== null && typeof api.remove === "function") {
            try { api.remove(widgetId); } catch (removeError) {}
          }
          host.replaceChildren();
          if (error) reject(error);
          else resolve(token);
        }
        host.replaceChildren();
        try {
          widgetId = api.render(host, {
            sitekey: sitekey,
            action: ACTION,
            appearance: "interaction-only",
            execution: "execute",
            callback: function (token) {
              if (!token) finish(new Error("TURNSTILE_TOKEN_EMPTY_V2"));
              else finish(null, token);
            },
            "error-callback": function () { finish(new Error("TURNSTILE_CHALLENGE_FAILED_V2")); },
            "expired-callback": function () { finish(new Error("TURNSTILE_CHALLENGE_EXPIRED_V2")); },
            "timeout-callback": function () { finish(new Error("TURNSTILE_CHALLENGE_TIMEOUT_V2")); }
          });
          api.execute(widgetId);
        } catch (error) {
          finish(error);
        }
      });
    });
  }

  window.WynchArticleClubTurnstileV2 = Object.freeze({ action: ACTION, challenge: challenge });
})();
